import { Label } from '@/shared/ui/label';
import { Textarea } from '@/shared/ui/textarea';

interface RegraCartaoEditorProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

/**
 * Editor de `regraCartao` como JSON livre. O objeto tem ~20 campos
 * possíveis que variam conforme `tipo` (cashback, pontos, regra-de-valor,
 * regra-fixa, regua de faixas, config de pesquisa NPS...) e nunca teve
 * uma tela de edição em lugar nenhum do sistema — em vez de mapear um
 * form dinâmico por tipo, deixamos o operador editar o JSON diretamente,
 * pré-preenchido com o valor do client de origem. Só validamos "é JSON
 * válido?", não o formato interno.
 */
export function RegraCartaoEditor({ value, onChange, error }: RegraCartaoEditorProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="regraCartaoEditor">regraCartao (JSON)</Label>
      <Textarea
        id="regraCartaoEditor"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={10}
        spellCheck={false}
        className="font-mono text-xs"
        placeholder="{}"
      />
      <p className="text-xs text-muted-foreground">
        Pré-preenchido com o regraCartao do cliente de origem. Edite livremente — só validamos se
        continua sendo um JSON válido.
      </p>
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
